import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Text } from '@change-corgi/design-system-legacy/typography';

export const Loading: React.FC = () => {
	return (
		<Card
			p="24px"
			backgroundColor="white"
			data-qa="grow-petition-share-visual-container"
			data-testid="grow-petition-share-visual-loading-container"
			sx={{ border: 'unset', borderRadius: 'big' }}
		>
			<Spinner role="progressbar" className="mx-auto mb-5 size-4" aria-label="progressbar" />
			<Text as="div" size="large" sx={{ textAlign: 'center' }}>
				<Translate value="corgi.petition.starter_dashboard.shared.share_visuals.modal_loading_copy" />
			</Text>
		</Card>
	);
};
